
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

export default function WishlistSpaceLimitModal({ 
  isOpen, 
  onClose, 
  onContinueWithoutImages, 
  onManageProducts, 
  onCreateNewWishlist 
}) {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('wishlistSpaceLimit.title')}
      showModal={isOpen}
      onClose={onClose}
      customContent={true}
    >
      <div style={styles.container}>
        <h3 style={styles.title}>
          {t('wishlistSpaceLimit.title')}
        </h3>
        
        <p style={styles.description}>
          {t('wishlistSpaceLimit.description')}
        </p>
        
        <div style={styles.optionsList}>
          <div style={styles.option}>
            <span style={styles.optionNumber}>1.</span>
            <span style={styles.optionText}>{t('wishlistSpaceLimit.option1')}</span>
          </div>
          
          <div style={styles.option}>
            <span style={styles.optionNumber}>2.</span>
            <span style={styles.optionText}>{t('wishlistSpaceLimit.option2')}</span>
          </div>
          
          <div style={styles.option}>
            <span style={styles.optionNumber}>3.</span>
            <span style={styles.optionText}>{t('wishlistSpaceLimit.option3')}</span>
          </div>
        </div>
        
        <div style={styles.buttonContainer}>
          <button
            onClick={onContinueWithoutImages}
            style={styles.primaryButton}
          >
            {t('wishlistSpaceLimit.continueWithoutImages')}
          </button>
          
          <button
            onClick={onManageProducts}
            style={styles.secondaryButton}
          >
            {t('wishlistSpaceLimit.manageProducts')}
          </button>
          
          <button
            onClick={onCreateNewWishlist}
            style={styles.secondaryButton}
          >
            {t('wishlistSpaceLimit.createNewWishlist')}
          </button>
          
          <button
            onClick={onClose}
            style={styles.cancelButton}
          >
            {t('wishlistSpaceLimit.understood')}
          </button>
        </div>
      </div>
    </Modal>
  );
}

const styles = {
  container: {
    padding: '20px',
    fontFamily: 'Poppins, sans-serif',
    maxWidth: '400px',
    margin: '0 auto'
  },
  title: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#000',
    marginBottom: '16px',
    textAlign: 'center'
  },
  description: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '20px',
    lineHeight: '1.5'
  },
  optionsList: {
    marginBottom: '24px'
  },
  option: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '12px',
    fontSize: '14px'
  },
  optionNumber: {
    fontWeight: '600',
    color: '#000',
    marginRight: '8px',
    minWidth: '20px'
  },
  optionText: {
    color: '#555',
    lineHeight: '1.4'
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  primaryButton: {
    background: '#000',
    color: '#fff',
    border: 'none',
    padding: '12px 16px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'opacity 0.2s ease'
  },
  secondaryButton: {
    background: '#f5f5f5',
    color: '#000',
    border: '1px solid #ddd',
    padding: '12px 16px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background 0.2s ease'
  },
  cancelButton: {
    background: 'transparent',
    color: '#666',
    border: 'none',
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer',
    textDecoration: 'underline'
  }
};
